import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(): boolean {
        if (sessionStorage.getItem('username') === null) {
            this.router.navigate(['/login']);
            return false; // Prevent navigation
        }
        return true; // Allow navigation
    }
}
